// extracted by css-extract-rspack-plugin
export default {"button":"subtitles-styles-button-61f78252","buttonContainer":"subtitles-styles-buttonContainer-08601885"};